/**
 * LandingHowItWorks - How it works section with steps
 */
import { Shield, ArrowUpDown, RefreshCw } from 'lucide-react';
import { useTranslation } from '../../i18n';

const LandingHowItWorks = () => {
  const { t } = useTranslation();
  
  const STEPS = [
    { 
      step: '01', 
      titleKey: 'landing.createAccount', 
      descKey: 'landing.createAccountDesc', 
      icon: Shield 
    },
    { 
      step: '02', 
      titleKey: 'landing.depositFunds', 
      descKey: 'landing.depositFundsDesc', 
      icon: ArrowUpDown 
    },
    { 
      step: '03', 
      titleKey: 'landing.startTransactingStep', 
      descKey: 'landing.startTransactingDesc', 
      icon: RefreshCw 
    }
  ];

  return (
    <section className="py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold mb-4">
            {t('landing.howItWorks')}
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            {t('landing.getStartedSteps')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {STEPS.map((item) => {
            const Icon = item.icon;
            return (
              <div key={`step-${item.step}`} className="relative">
                <div className="text-6xl font-heading font-bold text-emerald-500/10 absolute -top-4 -left-2">
                  {item.step}
                </div>
                <div className="relative z-10 pt-8">
                  <div className="w-14 h-14 rounded-xl bg-emerald-500 flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="font-heading font-semibold text-xl mb-2">{t(item.titleKey)}</h3>
                  <p className="text-muted-foreground">{t(item.descKey)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LandingHowItWorks;
